import { render, staticRenderFns } from "./step-contacts-location-region.vue?vue&type=template&id=2b2c8609"
import script from "./step-contacts-location-region.vue?vue&type=script&lang=ts"
export * from "./step-contacts-location-region.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports